require('./addImpositionDepositStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const moment = require('moment');
const { DATE_FORMAT_API } = require('constants/index');
// @ utilities
const { getAccountByImposition } = require('utilities/currentAccountsHelper.js');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const currencyHelper = require('utilities/currencyHelper');
// @ helpers
const { getLastNChars } = require('utilities/stringHelper');
// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

//@ commons
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

const PREFERENCES = {
    YES: "S",
    NO: "N"
};

class AddImpositionDepositStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }


    buildImpositionContent() {
        const {
            immAccounts,
            immDeposit,
            depositValue,
            setDepositValue,
            errorState,
            immStep,
            updateRenewalPreference,
            immDepositDetails
        } = this.props;
        const associatedAccountLabel = formatText('addImposition-accountAssociatedLabel');
        const importLabel = formatText('addImposition-accountAvailableBalance');
        const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
        const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
        const accountAvailableBalance = immAccount.get('balance');
        const plainAmountAccountAvailableBalance = currencyHelper.getPlainAmountObject(accountAvailableBalance);
        const language = getLanguage();
        const currencyCode = immDeposit.getIn(['amount', 'currency']);
        const currency = currencyHelper.formatCurrency(currencyCode);
        const aliasName =  immAccount.get('alias');
        const lastDigits = getLastNChars(immAccount.get('iban'));
        const interestRateLabel = formatText('addImposition-interestRateLabel');
        const tae = immDepositDetails.getIn(['depositsData', 'tasa']);
        const openingDateLabel = formatText('addImposition-openingDate');
        const openingDate = moment().format(DATE_FORMAT_API);
        const endDate = moment().add({days:1, months:13}).format(DATE_FORMAT_API);
        const dueDateLabel = formatText('addImposition-dueDate');
        const renewalLabel = formatText('addImposition-renewalLabel');
        const affirmativePreferenceText = formatText('addImposition-affirmativePreference');
        const negativePreferenceText = formatText('addImposition-negativePreference');
        const hasRenewal = immStep.get('hasRenewal');
        const renewalPreferenceResponse =  hasRenewal === PREFERENCES.YES ? affirmativePreferenceText : negativePreferenceText;

        const moneda = immDepositDetails.getIn(['depositsData', 'moneda']);
        const importeMin = immDepositDetails.getIn(['depositsData', 'importeMin']);
        const importeMax = immDepositDetails.getIn(['depositsData', 'importeMax']);
        const minAmount = currencyHelper.formatWithoutRound(importeMin, 0, language);
        const maxAmount = currencyHelper.formatWithoutRound(importeMax, 0, language);
        const monedaCode = currencyHelper.formatCurrency(moneda);

        const minString = `${minAmount} ${monedaCode}`;
        const maxString = `${maxAmount} ${monedaCode}`;
        const errorMessage = formatText('addImposition-inputErrorStep1', [
            minString,
            maxString
        ]);

        return (
            <section className="add-imposition__content no-print-out">
                <OKInformativeList columns={2}>
                    <OKInformativeListItem className="add-imposition__item" compact={true} title={associatedAccountLabel}>
                        <div className="add-imposition__value">
                            {aliasName}{lastDigits}
                        </div>
                    </OKInformativeListItem>
                    <OKInformativeListItem className="add-imposition__item" compact={true} title={importLabel}>
                        <div className="add-imposition__value">
                            <OneLineSymbolAmount
                                className="add-imposition__list-sub-title"
                                amountObject={plainAmountAccountAvailableBalance}
                                language={language}
                                amountObjectFormatted={currencyHelper.formatAmountObject(plainAmountAccountAvailableBalance, true)}
                            />
                        </div>
                    </OKInformativeListItem>
                </OKInformativeList>
                <div className="add-imposition__input">
                    <div className="add-imposition__import-label">
                        <FormattedText value="addImposition-importeLabel" />
                    </div>
                    <div className="add-imposition__import-input">
                        <AmountInput
                            id="inp_addImpositionStep1_amount"
                            amount={depositValue}
                            callback={setDepositValue}
                            min={0}
                            showBlurZero
                            hideFocusZero
                            error={errorState}
                            errorMsg={errorMessage}
                        />
                        <span className="add-imposition__currency">
                            {currency}
                        </span>
                    </div>
                    <div className="add-imposition__import-info">
                        <ul>
                            <li>
                                <div>
                                    <FormattedText value="addImposition-validationTextPart1" /><i className="icon-informacion"/>
                                </div>
                                <div>
                                    <FormattedText
                                        value="addImposition-validationCopyPart2"
                                        injectedStrings={[minAmount, maxAmount]}
                                        /><i className="icon-informacion"/>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="add-imposition__imposition-preferences">
                    <div className="add-imposition__renewal-preference">
                        <span className="add-imposition__renewal-preference-title">{renewalLabel}</span>
                        <RadioButtonGroup
                            name="renewalPreference"
                            idPrefix="renewalPreferenceRadio"
                            className="add-imposition____radio-group"
                            selectedValue={hasRenewal}
                            onChange={updateRenewalPreference}
                        >
                            <RadioButton label={affirmativePreferenceText} value={PREFERENCES.YES} className="add-imposition__radio"/>
                            <RadioButton label={negativePreferenceText} value={PREFERENCES.NO} className="add-imposition__radio"/>
                        </RadioButtonGroup>
                    </div>
                </div>
                <div className="add-imposition__imposition-info">
                    <OKInformativeList>
                        <OKInformativeListItem className="add-imposition__item" compact={true} title={interestRateLabel}>
                            <div className="add-imposition__value">
                                {tae}
                            </div>
                        </OKInformativeListItem>
                        <OKInformativeListItem className="add-imposition__item" compact={true} title={openingDateLabel}>
                            <div className="add-imposition__value">
                                {openingDate}
                            </div>
                        </OKInformativeListItem>
                        <OKInformativeListItem className="add-imposition__item" compact={true} title={dueDateLabel}>
                            <div className="add-imposition__value">
                                {endDate}
                            </div>
                        </OKInformativeListItem>
                        <OKInformativeListItem className="add-imposition__item" compact={true} title={renewalLabel}>
                            <div className="add-imposition__value">
                                {renewalPreferenceResponse}
                            </div>
                        </OKInformativeListItem>
                    </OKInformativeList>
                </div>
            </section>
        )
    }

    render() {
        const {
            immAccounts,
            immDeposit,
            depositValue,
            immStep,
            immDepositDetails
        } = this.props;

        const openingDate = moment().format(DATE_FORMAT_API)
        const endDate = moment().add({days:1, months:13}).format(DATE_FORMAT_API);
        const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
        const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
        const accountHolderName = immAccount.get('accountHolder');
        const tae = immDepositDetails.getIn(['depositsData', 'tasa']);
        const depositDescription = immDeposit.get('description');

        const confirmationTextAffirmativePreference = formatText('addImposition-confirmationTextAffirmativePreference');
        const confirmationTextNegativePreference = formatText('addImposition-confirmationTextNegativePreference');
        const hasRenewal = immStep.get('hasRenewal');
        const confirmationMessageLastPart = hasRenewal === PREFERENCES.YES ? confirmationTextAffirmativePreference : confirmationTextNegativePreference;

        const message = (
            <div>
                <p>
                    <FormattedText value="accountModifyStep1-agreeMessage" injectedStrings={[accountHolderName]}/>
                </p>
                <p>
                    <FormattedText value="addImposition-confirmationAddImpositionMessage" injectedStrings={[depositValue,depositDescription,tae,openingDate,endDate,confirmationMessageLastPart]} />
                </p>
                <p>
                    <FormattedText value="accountModifyStep1-satisficationMessage" injectedStrings={[accountHolderName]}/>
                </p>
            </div>
        );

        return (
            <article className="add-imposition">
                <header className="wizard_header">
                    <h1 className="add-imposition__title no-print-out">
                        <FormattedText value="addImposition-step1HeadText" />
                    </h1>
                </header>
                {this.buildImpositionContent()}
                <div className="add-imposition__row-info">
                    <h1 className="add-imposition__title no-print-out">
                        <FormattedText value="addImposition-confirmInfoTitle" />
                    </h1>
                    <section className="add-imposition__sub-title no-print-out">
                        <FormattedText value="accountModifyStep1-blockInfoSubTitle" />
                    </section>
                    <BlockInfo extraClass="add-imposition__block-info">
                        {message}
                    </BlockInfo>
                </div>
            </article>
        );
    }
}

AddImpositionDepositStep1.propTypes = {
    immAccounts: PropTypes.object,
    immDeposit: PropTypes.object,
    immImposition: PropTypes.object,
    immProfileFields: PropTypes.object,
    immDepositDetails: PropTypes.object,
    setDepositValue: PropTypes.func,
    updateRenewalPreference: PropTypes.func,
    immStep: PropTypes.object,
    depositId: PropTypes.string,
    depositValue: PropTypes.number,
    errorState: PropTypes.bool
};

module.exports = AddImpositionDepositStep1;

